const arcProgressBar = {
    props: {
        stepNumber: {
            type: String,
            default: "1",
        },
        strokeWidth: {
            type: Number,
            default: 2.5,
        },        
        activePerc: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            min: 0,
            max: 153,
            cValue: 0,
            maxLength: 251.2,
            bgDashArray: ""
        }
    },
    template: `<div class="b-arc-progress-bar">
    <div class="b-arc-progress-bar__bar">
        <svg ref="svg" width="100" height="100" viewbox="0 0 100 100" style="transform: rotate(-110deg);">

            <defs>
                <linearGradient id="linear" x1="100%" y1="100%" x2="100%" y2="0%">
                <stop offset="0%"   stop-color="#00a3e0"/>
                <stop offset="100%" stop-color="#68996c"/>
                </linearGradient>
            </defs>

            <path  class="progressBar" ref="progress" stroke-linecap="round" :stroke-width="strokeWidth" stroke="url(#linear)" fill="none" :stroke-dasharray="cValue" 
                d="M50 10 a 40 40 0 0 1 0 80 a 40 40 0 0 1 0 -80">
            </path>
            <path class="progressBg" ref="progressBg" stroke-linecap="round" :stroke-width="strokeWidth" stroke="#f2f2f2" fill="none" :stroke-dasharray="bgDashArray"
                d="M50 10 a 40 40 0 0 1 0 80 a 40 40 0 0 1 0 -80">
            </path>
        </svg>
    </div>
</div>`,
    mounted(){

        this.setValue(0)
        //this.cValue = `0, ${this.maxLength}`


        setTimeout(()=>{
            this.setValue(this.activePerc)
        },1000)
        
        this.bgDashArray = `${this.max}, ${this.maxLength}`
    },
    methods:{
        calcVal(perc){
            return (perc * this.max) / 100
        },
        setValue(perc){
            var num = this.calcVal(perc)            
            this.cValue = `${num}, ${this.maxLength}`

            // jQuery({ Counter: 0 }).animate({ Counter: num }, {
            //     duration: 1000,
            //     easing: 'linear',
            //     step: (final) => {
            //       this.cValue = `${final.toFixed(2)}, ${this.maxLength}`
            //     }
            //   });

        }
    }
};
